import { Helmet } from "react-helmet-async"
import { FileDetailsLayout } from "../../../../../../../../../../DataDrive/List"
import { useNavigate, useParams } from "../../../../../../../../../../router"
import useFolderDetailsOutletContext from "../../../../../_folder-details-context"

export default function FileVersionsViewPage() {
	const { fileId, versionId } = useParams(
		"/data-drive/folders/:folderId/files/:fileId/versions/:versionId/view"
	)
	const { folderDetails, refreshFolderDetails } =
		useFolderDetailsOutletContext()
	const navigate = useNavigate()
	function navigateBackOrToList() {
		return navigate("/data-drive")
	}
	return (
		<>
			<Helmet>
				<title>View version file</title>
			</Helmet>
			<FileDetailsLayout
				folderDetails={folderDetails}
				refreshFolderDetails={refreshFolderDetails}
				fileId={fileId}
				versionId={versionId}
				onSuccess={navigateBackOrToList}
			/>
		</>
	)
}
